import { css } from 'astroturf';
import React from 'react';

import Accenture from '../../assets/images/brands/accenture.svg';
import BaseCamp from '../../assets/images/brands/basecamp.svg';
import Harvard from '../../assets/images/brands/harvard.svg';
import Nist from '../../assets/images/brands/nist.svg';
import Oracle from '../../assets/images/brands/oracle.svg';
import Zillow from '../../assets/images/brands/zillow.svg';
import ChakraUI from '../../assets/images/brands/chakraui.svg';
import Pearson from '../../assets/images/brands/pearson.svg';
import Buffer from '../../assets/images/brands/buffer.svg';
import NIH from '../../assets/images/brands/nih.svg';
import Adobe from '../../assets/images/brands/adobe.svg';
import Brow from './Brow';

const styles = css`
  .brands {
    position: relative;
    padding-left: calc(2rem + env(safe-area-inset-left, 0));
    padding-right: calc(2rem + env(safe-area-inset-right, 0));
    text-align: center;
    color: #0a1530;
    margin: 0 auto;
    max-width: 1400px;
    z-index: 1;
    padding: 2.5rem 1rem 2.5rem;

    @media (min-width: 600px) {
      padding: 8rem 2rem 5rem;
      display: block;
    }

    & h2 {
      font-weight: 900;
      font-size: clamp(18px, 16px + 4vw, 44px);
      letter-spacing: -0.015em;
      line-height: 1.25;
      margin: auto;
      margin-bottom: 0.5rem;
      margin-top: 0;
      max-width: 60rem;
    }

    & p {
      font-size: calc(16px + 0.25vw);
      font-weight: 400;
      position: relative;
      max-width: 52rem;
      margin: 0 auto 1.5rem;
      line-height: 1.75;
      @media (min-width: 770px) {
        font-size: 1.17rem;
      }
    }

    & > div {
      max-width: 52rem;
      position: relative;
      margin: 2rem auto 0;
      padding-left: 0.5rem;
      padding-right: 0.5rem;
      display: flex;
      justify-content: space-around;
      align-items: center;
      align-content: center;
      flex-wrap: wrap;
      gap: 2rem 2rem;

      & > *:nth-child(1n + 7) {
        display: none;
      }
      @media (min-width: 600px) {
        gap: 2rem 3rem;
        & > *:nth-child(1n + 7) {
          display: block;
        }
      }
    }
  }
`;

function Brands(props) {
  return (
    <div className={[styles.brands, props.negtop ? styles.negtop : '', props.blend ? styles.blend : ''].join(' ')}>
      <Brow>These companies use Polypane</Brow>
      <h2>Trusted by developers shipping work that matters.</h2>
      <div>
        <Adobe width={80} height={40} />
        <NIH width={70} height={32} />
        <Zillow width={89} height={26} style={{ filter: 'brightness(0)' }} />
        <ChakraUI width={120} height={32} style={{ filter: 'saturate(0)' }} />
        <BaseCamp width={130} height={40} style={{ filter: 'saturate(0)' }} />
        <Accenture width={100} height={26} style={{ marginTop: '-0.7em', filter: 'brightness(0)' }} />
        <Harvard width={110} height={32} />
        <Oracle width={110} height={38} style={{ filter: 'saturate(0) brightness(0)' }} />
        <Pearson width={100} height={26} />
        <Nist width={70} height={32} />
        <Buffer width={85} height={26} style={{ filter: 'saturate(0)' }} />
      </div>
    </div>
  );
}

export default Brands;
